export default __webpack_public_path__ + "static/media/boschsans_bold.d49df8a9.woff2";